/**
 * BasicInfoSection.tsx
 * 顧客名(インライン編集), 予約種別(ラジオ), 予約番号, Square請求書（明細 + 発行/開く/取消）
 */
import React from 'react';
import { SectionProps } from '../types';
import SectionHeader from '../shared/SectionHeader';
import FieldDisplay from '../shared/FieldDisplay';
import InlineEditField from '../shared/InlineEditField';
import SquarePaymentInfo from './SquarePaymentInfo';
import { getCdwBundle, getNocBundle } from '../../../lib/cdwBundle';
import ReservationKindField from '../shared/ReservationKindField';
import { FieldMarkWrap } from '../conflict/fieldState';

const CONTACT_CODE_FIELDS = ['contact_code'] as const;
const INVOICE_FIELDS = ['invoice_link'] as const;

interface BasicInfoSectionProps extends SectionProps {
  onInvoiceOpen?: () => void;
  onInvoiceCreate?: () => void;
  onInvoiceVoid?: () => void;
  isCreatingInvoice?: boolean;
  isVoidingInvoice?: boolean;
}

export default function BasicInfoSection({
  data,
  onChange,
  disabled,
  isNew,
  onOpenEdit,
  onInvoiceOpen,
  onInvoiceCreate,
  onInvoiceVoid,
  isCreatingInvoice,
  isVoidingInvoice,
}: BasicInfoSectionProps) {
  return (
    <>
      <SectionHeader title="基本情報" />
      <InlineEditField
        label="予約名"
        field="customer_name"
        value={data.customer_name}
        onChange={onChange}
        disabled={disabled}
      />
      {/* 予約種別: json_data.data['予約種別']。新規・既存どちらでも変更できる（2026-09-19） */}
      <ReservationKindField jsonData={data.json_data} onChange={onChange} disabled={disabled} />
      <FieldDisplay
        label="予約コード"
        value={data.contact_code}
        fields={CONTACT_CODE_FIELDS}
        onClick={
          isNew
            ? () => onOpenEdit?.('contact_code', '予約コード')
            : undefined
        }
      />
      <FieldMarkWrap fields={INVOICE_FIELDS}>
        <SquarePaymentInfo
          contactCode={data.contact_code}
          disabled={disabled}
          invoiceLink={data.invoice_link}
          onInvoiceLinkChange={(v) => onChange?.({ invoice_link: v })}
          onInvoiceOpen={isNew ? undefined : onInvoiceOpen}
          onInvoiceCreate={isNew ? undefined : onInvoiceCreate}
          onInvoiceVoid={isNew ? undefined : onInvoiceVoid}
          isCreatingInvoice={isCreatingInvoice}
          isVoidingInvoice={isVoidingInvoice}
          nocJoined={!!data.noc || getNocBundle(data.json_data).bundled}
          cdwJoined={!!data.cdw || getCdwBundle(data.json_data).bundled}
        />
      </FieldMarkWrap>
    </>
  );
}
